<div class="card-inner-main-div">
  <div class="card-main-title">
    <h4 class="card-title">{{ 'Tasks' | translate }}</h4>
    <hr class="hr">
  </div>
  <div class="tableColStyle without-borders-table">
    @if (!segTasks) {
      <div class="comments-loader">
        <img src="assets/images/loader.gif">
      </div>
    }
    @if (segTasks) {
      <div class="table-responsive">
        <table class="table">
          <tbody>
            @for (task of segTasks; track trackById($index, task)) {
              <tr>
                <td class="task-name">{{task?.name}}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>